import { MotifButton, MotifIcon, MotifModalBody, MotifModalFooter, MotifTextArea } from '@ey-xd/motif-react'
import React from 'react'
import axios from 'axios';
import { OptionsCell } from './ViewQuestionsTableRow';
import iconSvg from "../../assets/icons/icon.svg.json";

const AIRecommendedQuestionnaireUpdate = (props: any) => {
    const { questionIndex, content, selectedOptions, enabledOptions, backToQuestions, onOptionChange, requestParams, updateTableData } = props;
    const [customizedQuery, setCustomizedQuery] = React.useState('');
    const [aiRecommendation, setAiRecommendation] = React.useState('');

    const generate = () => {
        axios.post("/chat/history/questionnaire/ai-response", {
            questionKey: questionIndex,
            selectedOptions: selectedOptions.map((question: any) => {
                return (content?.table[`Top_${parseInt(question) + 1}`] ?? [])[questionIndex]
            }
            )
            ,
            customizedQuery: customizedQuery,
            ...requestParams,
        }).then((response) => {
            // console.log("here response  = == == :", response );
            setAiRecommendation(response?.data?.aiResponse);
        }).catch(() => {
            alert("Error in fetching the document");
        })
    }
    // const saveData = () => {
    //     axios.patch("/chat/history/questionnaire/ai-response/save", {
    //         questionKey: questionIndex,
    //         customizedQuery: customizedQuery,
    //         aiResponse: aiRecommendation,
    //         ...requestParams
    //     }).then((response) => {
    //         updateTableData(response?.data?.tableData[0].message?.content)
    //     }).catch(() => {
    //         alert("Error in fetching the document");
    //     })
    // }
    const sendApproval = () => {
        axios.post("/approval", {
            chatId: requestParams.chatId,
            engagementId: requestParams.engagementId,
            aiResponse: aiRecommendation,
            customizedQuery: customizedQuery,
            questionKey: questionIndex,
            selectedOptions: selectedOptions
        }).then((response) => {
            // updateTableData(response?.data?.tableData[0].message?.content)
            backToQuestions()
        }).catch(() => {
            alert("Error in fetching the document");
        })
    }
    const changeCustomizedQueryHandler = (e: any) => {
        setCustomizedQuery(e.target.value)
    }
    return (
        <>
            <MotifModalBody className='min-h-80 !pt-0'>
                <div className="flex gap-3 mt-3">
                    <div className="flex flex-col gap-2  w-[45%] max-sm:w-full">
                        <div>
                            <p>Question {questionIndex + 1}:</p>
                            <div className="mt-2 p-2 questionare-update-question-container bg-[#2E2E38]">
                                <p>{content?.table?.Requirement[questionIndex]}</p>
                            </div>
                        </div>
                        <div className="!w-full">
                            <OptionsCell Top_1={{
                                text: content?.table?.Top_1[questionIndex],
                                score: content?.table?.Score_1[questionIndex]
                            }} Top_2={{
                                text: content?.table?.Top_2[questionIndex],
                                score: content?.table?.Score_2[questionIndex]
                            }} Top_3={{
                                text: content?.table?.Top_3[questionIndex],
                                score: content?.table?.Score_3[questionIndex]
                            }} selected={selectedOptions} onChange={onOptionChange} enabledRecommendedOptions={enabledOptions} />
                        </div>
                    </div>
                    <div className="flex flex-col gap-5 w-[55%] max-sm:w-full">
                        <div className="flex flex-col gap-3">
                            <p>Please type in your customized statement to generate AI output:</p>
                            <MotifTextArea
                                placeholder='Customized query'
                                onChange={changeCustomizedQueryHandler}
                                value={customizedQuery}
                            />
                        </div>
                        <div className="">
                            <p>AI recommended output</p>
                            {!aiRecommendation && (
                                <div className="flex flex-col gap-6 items-center justify-center !min-h-[12rem]">
                                    <MotifIcon src={iconSvg["copy-icon"]} title='add-ico' />
                                    <p className="!max-w-[60%] text-center">AI output will be generated once you fill in the above field and press the 'Generate AI output' button</p>
                                </div>
                            )}
                            {aiRecommendation && (
                                <p className="mt-2">{aiRecommendation}</p>
                            )}
                        </div>
                    </div>
                </div>
            </MotifModalBody>
            <MotifModalFooter style={{ borderTop: "1px solid #ffffff26" }} className="!py-0">
                <div className="flex justify-between gap-2 my-4">
                    <div>
                        <MotifButton
                            variant="secondary"
                            className="!mt-0"
                            onClick={backToQuestions}
                            type="button"
                        >
                            Back to questions
                        </MotifButton>
                    </div>
                    <div className="flex justify-end gap-2">
                        {/* <MotifButton
                            variant="secondary"
                            className="!mt-0"
                            onClick={saveData}
                            type="button"
                            disabled={!aiRecommendation}
                        >
                            Save data
                        </MotifButton> */}
                        <MotifButton
                            variant="secondary"
                            className="!mt-0"
                            onClick={sendApproval}
                            type="button"
                            disabled={!aiRecommendation}
                        >
                            Send For Approval
                        </MotifButton>
                        <MotifButton
                            className="!mt-0"
                            onClick={generate}
                            type="button"
                        >
                            Generate AI Output
                        </MotifButton>
                    </div>
                </div>
            </MotifModalFooter>
        </>
    )
}

export default AIRecommendedQuestionnaireUpdate